import { useTranslation } from 'react-i18next';
import { Quote } from 'lucide-react';

export default function CaseStudyTestimonial({ testimonial }) {
  const { t } = useTranslation();
  if (!testimonial) return null;

  return (
    <section className="max-w-7xl mx-auto px-6 lg:px-12 py-20" aria-label={t('case_study_testimonial.customer_testimonial')}>
      <div className="relative">
        {/* Background accent */}
        <div className="absolute inset-0 bg-gradient-to-br from-amber-500/5 to-transparent" />

        <div className="relative grid grid-cols-1 md:grid-cols-12 gap-8 items-center">
          {/* Photo */}
          {testimonial.photo && (
            <div className="md:col-span-3 flex justify-center md:justify-start">
              <div className="relative">
                <div className="absolute inset-0 bg-amber-500/20 translate-x-2 translate-y-2" />
                <img
                  src={testimonial.photo}
                  alt={testimonial.name}
                  className="relative w-24 h-24 md:w-32 md:h-32 grayscale object-cover border border-zinc-800"
                  loading="lazy"
                  decoding="async"
                />
              </div>
            </div>
          )}

          {/* Quote */}
          <div className={testimonial.photo ? "md:col-span-9" : "md:col-span-12"}>
            <Quote className="w-8 h-8 text-amber-500/30 mb-4" aria-hidden="true" />
            <blockquote className="text-xl md:text-2xl lg:text-3xl text-zinc-200 leading-relaxed mb-8 font-display uppercase">
              &ldquo;{testimonial.quote}&rdquo;
            </blockquote>
            <div className="flex items-center gap-3">
              <div className="w-8 h-[1px] bg-amber-500" />
              <div>
                <div className="font-display text-sm uppercase text-white">
                  {testimonial.name}
                </div>
                <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-400 mt-1">
                  {testimonial.role}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
